import { ApplicationRef, enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { devTools } from '@ngneat/elf-devtools';

if (environment.production) {
    enableProdMode();
}

platformBrowser()
    .bootstrapModule(AppModule)
    .then(moduleRef => {
        if (!environment.production) {
            devTools({
                postTimelineUpdate: () =>
                    moduleRef.injector.get(ApplicationRef).tick(),
            });
        }
    })
    .catch(err => console.error(err));
